document.addEventListener('DOMContentLoaded', () => {
  // Welcome popup — email capture for 5% off (WELCOME5). Skips signed-in
  // customers and anyone already subscribed. If a visitor closes it without
  // subscribing, it stays quiet for the rest of that browser session and
  // will show again on their next visit (new tab/window session).
  const overlay = document.querySelector('[data-welcome-popup-overlay]');
  if (!overlay) return;

  const SUBSCRIBED_KEY = 'decusWelcomePopupSubscribed';
  const SESSION_KEY = 'decusWelcomePopupSession';
  const SHOW_DELAY_MS = 4000;

  function isSubscribed() {
    try { return localStorage.getItem(SUBSCRIBED_KEY) === '1'; } catch (e) { return false; }
  }
  function markSubscribed() {
    try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) {}
  }
  function isDismissedThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markDismissedThisSession() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  const alreadyHandled = isSubscribed() || isDismissedThisSession();
  const loggedIn = !!(window.Decus && window.Decus.customerLoggedIn);

  if (alreadyHandled || loggedIn) return;

  function openPopup() {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(() => { overlay.hidden = true; }, 300);
  }
  function dismiss() {
    clearTimeout(showTimer);
    markDismissedThisSession();
    closePopup();
  }

  const showTimer = setTimeout(openPopup, SHOW_DELAY_MS);

  const closeBtn = overlay.querySelector('[data-welcome-popup-close]');
  if (closeBtn) closeBtn.addEventListener('click', dismiss);

  overlay.addEventListener('click', (e) => { if (e.target === overlay) dismiss(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) dismiss();
  });

  const form = overlay.querySelector('[data-welcome-popup-form]');
  const errorEl = overlay.querySelector('[data-welcome-popup-error]');
  const formState = overlay.querySelector('[data-welcome-popup-form-state]');
  const successState = overlay.querySelector('[data-welcome-popup-success]');

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const emailInput = form.querySelector('input[name="email"]');
      const email = ((emailInput && emailInput.value) || '').trim();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.hidden = false; }
        return;
      }

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Please wait…'; }

      const body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[tags]', 'newsletter,welcome-popup');
      body.set('contact[email]', email);
      body.set('contact[accepts_marketing]', 'true');

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).then(() => {
        markSubscribed();
        markDismissedThisSession();
        if (formState) formState.hidden = true;
        if (successState) successState.hidden = false;
      }).catch(() => {
        if (errorEl) { errorEl.textContent = 'Something went wrong — please try again.'; errorEl.hidden = false; }
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Get My Code'; }
      });
    });
  }

  const copyBtn = overlay.querySelector('[data-welcome-popup-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      const codeEl = overlay.querySelector('[data-welcome-popup-code] span');
      const code = codeEl ? codeEl.textContent.trim() : 'WELCOME5';
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(() => {
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('is-copied');
          setTimeout(() => { copyBtn.textContent = 'Copy'; copyBtn.classList.remove('is-copied'); }, 2000);
        });
      }
    });
  }

  const shopNowBtn = overlay.querySelector('[data-welcome-popup-shop-now]');
  if (shopNowBtn) shopNowBtn.addEventListener('click', () => { markSubscribed(); });
});
